export const isDateValid = (date) => {
    const d = typeof date === "string"
        ? new Date(date)
        : date;
    return !!d.getDate();
};
